module.exports = __webpack_public_path__ + "img/nc-windows.0dc94b1e.jpg";